/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { useAppConfig } from '../../_shared/hooks/useAppConfig';
import Logo from '../../_shared/logo';
import { Row } from '../../_shared/row';
import colors from '../../_shared/colors';

const style = {
  row: `
    font-size: 11px; 
    font-style: italic; 
    color: ${colors.lightText}; 
    align-items: flex-end;
    justify-content: flex-end;

    span {
      margin-right: 5px;
      position: relative;
      bottom: -2px;
    }
  `,
};

export const LoginLogo = (props: any) => {
  const app = useAppConfig() as any;

  return (
    <div>
      <Logo size="xlarge" />
      {!!app.logo && (
        <Row css={css(style.row)}>
          <span>Powered by</span> <Logo src={app.aerasLogo} size="medium" />
        </Row>
      )}
    </div>
  );
};
